import {AES, enc}from 'crypto-js';
import Cookies from 'cookies-js';
import { v4 as uuidv4 } from 'uuid';
import { fetchTokenPath, redirectURIPath } from '../../Services/config/apiGateway';


export const fetchRefreshToken = ({ clientId, scopes, clientSecret, code, state, tokenEndpoint, fetch = window.fetch }) => {
  let uuID = uuidv4();
  const payload = {
    client_id: '8c19ff6c-0af1-48e9-b5ef-005a9a59e409',
    code,
    grant_type: 'authorization_code',
    code_verifier: state.encodedVerifier,
    redirect_uri: state.redirect_uri,
    scope:"8c19ff6c-0af1-48e9-b5ef-005a9a59e409 offline_access"
  };
  if (clientSecret) {
    payload.client_secret = clientSecret
  }
  const refreshToken =  sessionStorage.getItem("isAuthenticated")
  const decrypted = AES.decrypt(refreshToken, 'itsEncrypted');
const decryptedObject = decrypted.toString(enc.Utf8);
  //const refreshToken =  sessionStorage.getItem("isAuthenticated")
  const getRefreshToken = JSON.parse(decryptedObject)
  //console.log(getRefreshToken)
  // https://tpt-apim-cargo-test.azure-api.net/ccLogin/v1/tokenprofiledetails?grant_type=refresh_token&redirect_uri=http://localhost:3000&code_verifier=${state.encodedVerifier}&refresh_token=${getRefreshToken.tokenResponse.refresh_token}
  
 // console.log(getRefreshToken.refresh_token,"<<<<<<<<>>>>>>>")
  return fetch(`${fetchTokenPath}tokenprofiledetails?grant_type=refresh_token&redirect_uri=${redirectURIPath}/&code_verifier=${state.encodedVerifier}&refresh_token=${getRefreshToken.tokenResponse.refresh_token}`, {
    headers: {
      //'Content-Type': 'application/x-www-form-urlencoded'
      'x-cc-trace-id': uuID ,
      "channel" : 'web',
      "appVersion" : 'v1.1.0'
    },
    method: 'GET',
    //body: new window.URLSearchParams(payload)
  })
    .then(r => {
      if (!r.ok) {
        throw new Error(`Token response not ok, status is ${r.status}`);
      }
      return r.json();
    })
    .then(token => {
      Cookies.set('msAL', token.tokenResponse.access_token, {expires: token.tokenResponse.expires_in, path:'/' });
      Cookies.set('_msAL', token.tokenResponse.access_token, {expires: token.tokenResponse.expires_in, path: '/' });
     // const ccMsalToken = AES.encrypt(JSON.stringify(token.tokenResponse),'itsEncrypted').toString();
      Cookies.set('ccMsal',JSON.stringify(token.tokenResponse), {expires: token.tokenResponse.expires_in, path:'/' });
      const envryptedToken = AES.encrypt(JSON.stringify(token),'itsEncrypted').toString();
      sessionStorage.setItem("isAuthenticated",envryptedToken)
      console.log(token,"tutu")
      const { expires_in } = token;
      if (expires_in && Number.isFinite(expires_in)) {
        const slackSeconds = 10;
        // add 'expires_at', with the given slack
        token.expires_at = new Date(new Date().getTime() + expires_in * 1000 - (slackSeconds * 1000));
      }
      return token;
    })
    .catch(err => {
      console.error('ERR (fetch)', err);
      throw err;
    });
}

// import {AES, enc}from 'crypto-js';


// export const fetchRefreshToken = ({ clientId, scopes, clientSecret, code, state, tokenEndpoint, fetch = window.fetch }) => {
//   const payload = {
//     client_id: '8c19ff6c-0af1-48e9-b5ef-005a9a59e409',
//     code,
//     grant_type: 'authorization_code',
//     code_verifier: state.encodedVerifier,
//     redirect_uri: state.redirect_uri,
//     scope:"8c19ff6c-0af1-48e9-b5ef-005a9a59e409 offline_access"
//   };
//   if (clientSecret) {
//     payload.client_secret = clientSecret
//   }
//   const refreshToken =  sessionStorage.getItem("isAuthenticated")
//   const decrypted = AES.decrypt(refreshToken, 'itsEncrypted');
// const decryptedObject = decrypted.toString(enc.Utf8);
//   //const refreshToken =  sessionStorage.getItem("isAuthenticated")
//   const getRefreshToken = JSON.parse(decryptedObject)
//   console.log(getRefreshToken)

  
//  // console.log(getRefreshToken.refresh_token,"<<<<<<<<>>>>>>>")
//   return fetch(`https://tpt-apim-cargo-test.azure-api.net/ccLogin/v1/token?grant_type=refresh_token&client_id=8c19ff6c-0af1-48e9-b5ef-005a9a59e409&scope=8c19ff6c-0af1-48e9-b5ef-005a9a59e409 offline_access&redirect_uri=http://localhost:3000&code_verifier=${state.encodedVerifier}&refresh_token=${getRefreshToken.tokenResponse.refresh_token}`, {
//     // headers: {
//     //   'Content-Type': 'application/x-www-form-urlencoded'
//     // },
//     method: 'POST',
//     //body: new window.URLSearchParams(payload)
//   })
//     .then(r => {
//       if (!r.ok) {
//         throw new Error(`Token response not ok, status is ${r.status}`);
//       }
//       return r.json();
//     })
//     .then(token => {
//       const envryptedToken = AES.encrypt(JSON.stringify(token),'itsEncrypted').toString();
//       sessionStorage.setItem("isAuthenticated",envryptedToken)
//       const { expires_in } = token;
//       if (expires_in && Number.isFinite(expires_in)) {
//         const slackSeconds = 10;
//         // add 'expires_at', with the given slack
//         token.expires_at = new Date(new Date().getTime() + expires_in * 1000 - (slackSeconds * 1000));
//       }
//       return token;
//     })
//     .catch(err => {
//       console.error('ERR (fetch)', err);
//       throw err;
//     });
// }
